// extracted by mini-css-extract-plugin
export default {"savedCardDetailsWrapper":"saved-payment-details-form_savedCardDetailsWrapper__3cbd3"};